import { render, staticRenderFns } from "./StandstInfoModal.vue?vue&type=template&id=16d52689"
import script from "./StandstInfoModal.vue?vue&type=script&lang=js"
export * from "./StandstInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports